import styled from 'styled-components';
import { MentionsInput } from 'react-mentions';


export const WrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${({ disabled }) => (disabled ? '#EFF1F5' : 'white')};
  height: 2.68rem;
  box-sizing: border-box;
  border-radius: 8.47434px;
  line-height: 0.875rem;
  font-size: 0.70833rem; 
  letter-spacing: 0px;
  color: #111;

  Button {
    background: ${({ focus }) => (!focus ? '#585E66' : '#40E5A0')};
    color: ${({ focus }) => (!focus ? '#EFF1F5' : '#42464C')};
    width: 4rem;
    height: 3.5rem;
  }
  &:hover {
    Button {
      color: #42464c;
    }
  }
`;

export const CustomMentionInput = styled(MentionsInput)`
    min-width: 90%;
    font-size: 0.8rem; // Tamanho da fonte
    height: 3.5rem;


    textarea:focus{   
      outline: none;
      border-color: #40e5a0 ;        
  }

  .user-mention {
 
    display: flex;
    align-items: center;
    padding: 4px;


    img {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .name {
      margin-right: 10px;
      
    }

    .email {
      color: #888;
    }

    :hover{
      background-color: #d6e5fa;
    }

  }
 
`;
